
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'AboutHero',
  setup() {
    const pageLoaded = ref(false)

    setTimeout(() => {
      pageLoaded.value = true
    }, 0)

    return {
      pageLoaded,
    }
  },
})
